import { Component } from '@angular/core';

@Component({
  selector: 'fl-media-object',
  template: `
    <div flLayout flLayoutGap="small" flLayoutAlign="start center">
      <div class="Thumbnail" flLayoutFlex="0 1 auto">
        <ng-content select="fl-media-object-thumbnail"></ng-content>
      </div>
      <div class="Content" flLayoutFlex="1 1 auto">
        <ng-content select="fl-media-object-content"></ng-content>
      </div>
    </div>
  `,
  styleUrls: ['./media-object.component.scss'],
})
export class MediaObjectComponent {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/pl/webapp/src/app/@shared/ui/media-object/media-object.component.ts